import { Component, OnInit } from '@angular/core';
import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { CoreBuildingBlock } from '../../shared/building-block.decorator';

@CoreBuildingBlock('dropdown')
@Component({
  selector: 'cu-dropdown',
  templateUrl: './dropdown.component.html',
  standalone: false
})
export class DropdownComponent extends CoreBuildingBlockControlBaseComponent implements OnInit {
  public showSelectOne = false;

  // public ngOnInit(): void {
  //   this.showSelectOne = !this.field.enum.find((field) => String(field.value) === this.field.data.valueString);
  // }

  /**
   * Show default value
   */
  public get showDefault(): boolean {
    return !this.field.enum.find((field) => String(field.value) === this.field.data.valueString);
  }
}
